import { useEffect } from 'react';

const StructuredData = () => {
  useEffect(() => {
    // Local Business Schema
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "SportsActivityLocation",
      "@id": "https://san-kai-karate-fullv2.vercel.app/#organization",
      "name": "San Kai Karate Association",
      "alternateName": "San Kai Karate Clacton-on-Sea",
      "description": "Traditional, fun, family-friendly karate dojo in Clacton-on-Sea offering Wado-Ryu martial arts training for all ages since 1988.",
      "url": "https://san-kai-karate-fullv2.vercel.app",
      "logo": "https://san-kai-karate-fullv2.vercel.app/logo192.png",
      "image": "https://san-kai-karate-fullv2.vercel.app/og-image.jpg",
      "telephone": "+44-7576-327340",
      "email": "ravirhiro@gmail.com",
      "priceRange": "££",
      "foundingDate": "1988",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Clacton-on-Sea",
        "addressLocality": "Clacton-on-Sea",
        "addressRegion": "Essex",
        "postalCode": "CO15",
        "addressCountry": "GB"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "51.7891",
        "longitude": "1.1506"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Friday"],
          "opens": "18:30",
          "closes": "20:30"
        }
      ],
      "sameAs": [
        "https://www.facebook.com/sankaikarate",
        "https://www.instagram.com/sankaikarate"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Karate Classes",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Kids Karate Classes",
              "description": "Fun and engaging karate classes for children aged 5 and above"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Adult Karate Classes",
              "description": "Traditional Wado-Ryu karate training for adults of all skill levels"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Family Karate Classes",
              "description": "Family-friendly martial arts training in a welcoming environment"
            }
          }
        ]
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5",
        "reviewCount": "25"
      },
      "potentialAction": {
        "@type": "JoinAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://san-kai-karate-fullv2.vercel.app/contact"
        }
      }
    };

    // Organization Schema
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "San Kai Karate Association",
      "url": "https://san-kai-karate-fullv2.vercel.app",
      "logo": "https://san-kai-karate-fullv2.vercel.app/logo192.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+44-7576-327340",
        "contactType": "customer service",
        "areaServed": "GB",
        "availableLanguage": "English"
      },
      "sameAs": [
        "https://www.facebook.com/sankaikarate",
        "https://www.instagram.com/sankaikarate"
      ]
    };

    // Website Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "San Kai Karate Association",
      "url": "https://san-kai-karate-fullv2.vercel.app",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://san-kai-karate-fullv2.vercel.app/?s={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    };

    // BreadcrumbList Schema
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://san-kai-karate-fullv2.vercel.app/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "About",
          "item": "https://san-kai-karate-fullv2.vercel.app/about"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Classes",
          "item": "https://san-kai-karate-fullv2.vercel.app/schedule"
        },
        {
          "@type": "ListItem",
          "position": 4,
          "name": "Pricing",
          "item": "https://san-kai-karate-fullv2.vercel.app/pricing"
        },
        {
          "@type": "ListItem",
          "position": 5,
          "name": "Contact",
          "item": "https://san-kai-karate-fullv2.vercel.app/contact"
        }
      ]
    };

    // Insert all schemas
    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.text = JSON.stringify(localBusinessSchema);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.text = JSON.stringify(organizationSchema);
    document.head.appendChild(script2);

    const script3 = document.createElement('script');
    script3.type = 'application/ld+json';
    script3.text = JSON.stringify(websiteSchema);
    document.head.appendChild(script3);

    const script4 = document.createElement('script');
    script4.type = 'application/ld+json';
    script4.text = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(script4);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
      document.head.removeChild(script4);
    };
  }, []);

  return null;
};

export default StructuredData;
